<template>
  <div class="edit">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <b>编辑账户(Edit Account)</b>
      </el-breadcrumb-item>
    </el-breadcrumb>
    <div v-if="detail.status === StatusEnum.BANNED.id" class="banned-tip">
      <p>您的账户已被封禁，如有问题请联系您的专属运营经理。</p>
      <p>Your account has been blocked. If you have any questions, please contact your dedicated account manager.</p>
    </div>
    <el-form class="detail" :model="detail" :rules="rule" label-width="250px" ref="form">
      <el-form-item :label="item.label" :prop="item.prop" v-for="item in config" style="margin-top: 20px"
                    :key="item.prop">
        <el-select v-if="item.prop === 'industryId'" v-model="detail[item.prop]"
                   placeholder="请选择所属行业/Select Industry" filterable clearable>
          <el-option v-for="option in industryList" :key="option.id" :value="option.id" :label="option.displayName"/>
        </el-select>
        <el-select v-else-if="item.prop === 'districtId'" v-model="detail[item.prop]"
                   placeholder="请选择/Select Country/District" filterable clearable>
          <el-option v-for="option in districtList" :key="option.id" :value="option.id" :label="option.displayName"/>
        </el-select>
        <p v-else-if="item.prop === 'password'">
          Please connect operator if you forget the old password
        </p>
        <el-input v-else :type="item.type" :rows="5" v-model="detail[item.prop]" :maxlength="item.maxLength || null"
                  :placeholder="placeholderText(item.label)" :disabled="(['associateMail'].includes(item.prop))"
                  clearable></el-input>
        <div class="item-tip" v-if="item.tip" v-html="item.tip"/>
      </el-form-item>
      <el-form-item class="bottom-button">
        <el-button type="primary" @click="save">确认(Confirm)</el-button>
      </el-form-item>
    </el-form>
    <div style="width: 640px; text-align: center;">
      <hr>
      You have agreed to the
      <el-link href="/privacy_policy.html" target="_blank">Privacy Policy</el-link>
      and the
      <el-link href="/developer_agreement.html" target="_blank">Developer Agreement</el-link>
    </div>
  </div>
</template>

<script>
import {sspApi} from '@/api'
import store from '@/data/store'
import {placeholderText} from '@/tools/common-utils'
import {StatusEnum} from '@/enums/enums'

export default {
  data: function () {
    return {
      StatusEnum,
      industryList: [],
      districtList: [],
      detail: {
        name: '',
        status: '',
        companyName: '',
        associateMail: '',
        copyMail: '',
        industryId: null,
        districtId: null
      },
      config: [
        {prop: 'associateMail', label: '账户邮箱(Account Email)', type: 'text', maxLength: 50},
        {prop: 'name', label: '账户名称(Account Name)', type: 'text', maxLength: 50},
        {
          prop: 'companyName',
          label: '公司名称(Company Name)',
          type: 'text',
          maxLength: 200,
          tip: "Please use english company name"
        },
        {prop: 'industryId', label: '所属行业(Industry)'},
        {prop: 'districtId', label: '国家/地区(Country/District)'},
        {
          prop: 'copyMail',
          label: '抄送邮箱(CC Email)',
          type: 'textarea',
          maxLength: 500,
          tip: '多个抄送邮箱使用英文,分隔<br>Use commas to separate multiple CC emails'
        },
        {prop: 'password', label: '密码(Password)'}
      ],
      rule: {
        name: [
          {required: true, message: '请输入账户名称/Input Account Name', trigger: 'blur'},
        ],
        companyName: [
          {required: true, message: '请输入公司名称/Input Company Name', trigger: 'blur'},
        ],
        industryId: [
          {required: true, message: '请选择所属行业/Select Industry', trigger: 'blur'},
        ],
        districtId: [
          {required: true, message: '请选择/Select Country/District', trigger: 'blur'},
        ]
      }
    }
  },
  created: function () {
    sspApi.getAccountConfig().then(({industryList, account, districtList}) => {
      this.industryList = industryList;
      this.districtList = districtList;
      if (account) {
        this.detail = {
          ...this.detail,
          ...account
        };
      }
    }).catch(this.$rejectAjaxError());
  },
  methods: {
    placeholderText,
    save: function () {
      this.$element.checkForm(this.$refs.form);
      this.$confirm('确认提交(Confirm and submit)？', '', {
        confirmButtonText: '确认(Confirm)',
        cancelButtonText: '取消(Cancel)',
        type: 'info'
      }).then(() => {
        sspApi.editAccount({data: this.detail}).then((response) => {
          this.$message.success("Account details updated successfully");
          store.commit('setAccountInfo', response);
        }).catch(this.$rejectAjaxError());
      }).catch(() => {
      });
    }
  }
}
</script>
<style scoped>
.detail {
  font-size: 10px;
  padding-left: 20px;
}

.detail >>> .el-col {
  height: 30px;
  width: 40%;
}

.detail >>> .el-input, .detail >>> .el-textarea {
  width: 350px;
}

.bottom-button {
  width: 600px;
  text-align: right;
}

hr {
  border: none;
  height: 1px;
  background-color: #ccc;
  transform: scaleY(0.5);
  margin-bottom: 15px;
}

.banned-tip {
  margin-top: 20px;
  font-size: 14px;
  background-color: cornsilk;
  color: red;
  padding: 10px;
  width: 750px;
  border-radius: 3px;
}

.item-tip {
  color: #909399;
}
</style>
